<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>عرض بيانات شركة الحراسة</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #446e80">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form>
        <div class="row">
          <!-- Start:: Basic Information -->
          <div class="col-12 mb-4">
            <h5
              style="
                color: #446e80;
                border-bottom: 2px solid #446e80;
                padding-bottom: 10px;
              "
            >
              بيانات شركة الحراسة
            </h5>
          </div>

          <!-- Start:: Company Name -->
          <base-input
            col="6"
            type="text"
            placeholder="اسم شركة الحراسة"
            v-model.trim="data.name"
            disabled
          />
          <!-- End:: Company Name -->

          <!-- Start:: Mobile Number -->
          <base-input
            col="6"
            type="text"
            placeholder="رقم الجوال"
            v-model.trim="data.mobile"
            style="direction: ltr"
            disabled
          />
          <!-- End:: Mobile Number -->

          <!-- Start:: Email -->
          <base-input
            col="6"
            type="text"
            placeholder="البريد الالكتروني"
            v-model.trim="data.email"
            disabled
          />
          <!-- End:: Email -->

          <!-- Start:: Commercial Registration Number -->
          <base-input
            col="6"
            type="text"
            placeholder="رقم السجل التجاري"
            v-model.trim="data.commercial_registration_number"
            disabled
          />
          <!-- End:: Commercial Registration Number -->

          <!-- Start:: Status -->
          <base-input
            v-if="data.status"
            col="6"
            type="text"
            placeholder="الحالة"
            v-model.trim="data.status"
            disabled
          />
          <!-- End:: Status -->

          <!-- Start:: Join Request Date -->
          <base-input
            col="6"
            type="text"
            placeholder="تاريخ الطلب"
            v-model.trim="data.created_at"
            disabled
          />
          <!-- End:: Join Request Date -->

          <!-- Start:: Documents Section -->
          <div class="col-12 mt-4 mb-3">
            <h5
              style="
                color: #446e80;
                border-bottom: 2px solid #446e80;
                padding-bottom: 10px;
              "
            >
              المستندات المطلوبة
            </h5>
          </div>

          <!-- Start:: Commercial Registration Image -->
          <div class="col-12 mb-4">
            <h6 style="color: #446e80; margin-bottom: 15px">
              صورة السجل التجاري
            </h6>
            <div class="preview-container text-center">
              <img
                v-if="data.commercial_registration_image"
                :src="data.commercial_registration_image"
                alt="صورة السجل التجاري"
                style="
                  max-width: 100%;
                  max-height: 400px;
                  border-radius: 8px;
                  border: 1px solid #ddd;
                  cursor: pointer;
                "
                @click="openImageModal(data.commercial_registration_image)"
              />
              <p v-else class="text-muted">لا توجد صورة متاحة</p>
            </div>
          </div>
          <!-- End:: Commercial Registration Image -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "ShowProvider",
  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      file: null,
      fileType: "",

      // Start:: Data Collection To Send
      data: {
        id: null,
        name: null,
        email: null,
        mobile: null,
        status: null,
        status_enum: null,
        commercial_registration_number: null,
        commercial_registration_image: null,
        created_at: null,
      },
      // End:: Data Collection To Send
      areas: [],
      arabicRegex: /^[\u0600-\u06FF\s]+$/,
      EnRegex: /[\u0600-\u06FF]/,

      providerPoints: [],
      coordinates: [],
    };
  },

  methods: {
    disabledDate(current) {
      return current && current < moment().startOf("day");
    },

    onCopy(event) {
      event.preventDefault();
    },
    onPaste(event) {
      event.preventDefault();
    },

    validateInput() {
      // Remove non-Arabic characters from the input
      this.data.nameAr = this.data.nameAr.replace(/[^\u0600-\u06FF\s]/g, "");
    },
    removeArabicCharacters() {
      this.data.nameEn = this.data.nameEn.replace(this.EnRegex, "");
    },

    handleFileSelected({ file, fileType }) {
      this.file = file; // Store the selected file in your data
      this.fileType = fileType; // Store the selected file in your data
    },
    handleFileRemoved() {
      this.file = null; // Reset the file when it's removed
      this.fileType = "";
    },

    handleSaveProvider(coordinates) {
      // Handle the saved provider coordinates from the child component

      this.coordinates = coordinates;
    },
    // start show data
    async showData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `provider-joining/${this.$route.params?.id}`,
        });
        const companyData = res.data.data.data;

        this.data.id = companyData?.id;
        this.data.name = companyData?.name;
        this.data.email = companyData?.email;
        this.data.mobile = companyData?.mobile;
        this.data.status = companyData?.status;
        this.data.status_enum = companyData?.status_enum;
        this.data.commercial_registration_number =
          companyData?.commercial_registration_number;
        this.data.commercial_registration_image =
          companyData?.commercial_registration_image;
        this.data.created_at = companyData?.created_at;
      } catch (error) {
        this.loading = false;
        console.log(error?.response?.data?.message);
      }
    },

    // Open image in modal for better viewing
    openImageModal(imageUrl) {
      if (imageUrl) {
        window.open(imageUrl, "_blank");
      }
    },
    // end show data
  },

  created() {
    this.showData();
  },
  computed: {
    // Add any computed properties if needed
  },
};
</script>
<style scope>
.download_btn {
  color: #446e80 !important;
  transition: background-color 0.4s, color 0.4s;
}

.download_btn:hover {
  background-color: #446e80;
  color: #fff !important;
}
</style>
